<template>
  <div class="ee-card-buttons">
    <el-button class="r-button simple" @click="cancel" block>
      Отменить
    </el-button>
    <el-button
      class="r-button"
      type="primary"
      @click="save"
      :disabled="disabled"
    >
      Применить
    </el-button>
  </div>
</template>

<script>
export default {
  props: ["save", "cancel", "feature", "required"],
  computed: {
    disabled() {
      return this.required.some(prop => !this.feature[prop]);
    }
  }
};
</script>

<style lang="scss">
.ee-card-buttons {
  margin-top: 16px;
  display: flex;

  .el-button {
    flex: 1;

    &:last-child {
      margin-left: 16px;
    }
  }
}
</style>
